import React from "react";
import TextField from "@mui/material/TextField";

interface DateAndTimePickersProps {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function DateAndTimePickers({
  label,
  value,
  onChange,
}: DateAndTimePickersProps): JSX.Element {
  return (
    <TextField
      fullWidth
      id="datetime-local"
      label={label}
      value={value}
      onChange={(event) =>
        onChange(event as React.ChangeEvent<HTMLInputElement>)
      }
      type="datetime-local"
      sx={{
        ml: 1,
        mr: 1,
        width: 215,
      }}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
      }}
    />
  );
}
